import { useEffect, useRef, useState } from 'react';

const COUNTER_INITIAL_TIME_IN_MS = 3000;
const COUNTER_INTERVAL_IN_MS = 1000;
const MILLISECONDS_IN_SECOND = 1000;

export const PresentationCountdown = ({
  onCounterStart,
  onCounterDone,
  counterInitialTime = COUNTER_INITIAL_TIME_IN_MS,
  counterInterval = COUNTER_INTERVAL_IN_MS,
  counterTextStyle,
}: {
  onCounterStart: () => void;
  onCounterDone: () => void;
  counterInitialTime?: number;
  counterInterval?: number;
  counterTextStyle?: React.CSSProperties;
}) => {
  const [counterState, setCounterState] = useState<number>(
    Math.ceil(counterInitialTime / MILLISECONDS_IN_SECOND)
  );

  const counterIntervalRef = useRef<ReturnType<typeof setInterval> | null>(
    null
  );

  useEffect(() => {
    if (counterState === 0) {
      onCounterDone();
      if (counterIntervalRef.current) {
        clearInterval(counterIntervalRef.current);
      }
    }
  }, [counterState]);

  useEffect(() => {
    onCounterStart();
    counterIntervalRef.current = setInterval(() => {
      setCounterState((prev: number) => prev - 1);
    }, counterInterval);
    return () => {
      if (counterIntervalRef.current) {
        clearInterval(counterIntervalRef.current);
      }
    };
  }, []);

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center">
      <p
        className="text-white text-opacity-60 text-[411px] font-bold"
        style={counterTextStyle}
      >
        {counterState}
      </p>
    </div>
  );
};
